<div class="layout">
  <div class="layout__topbar-container">
    <osp-topbar></osp-topbar>
  </div>
  <div class="layout__body">
    <osp-whitelabeled-component
      [componentKey]="WhitelabeledComponentKey.SIDEBAR_MENU"
      [props]="sidebarProps"
      [defaultComponent]="SidebarComponent"
      class="layout__sidebar-container"
    />
    <div class="layout__right-column" [ngClass]="'layout__right-column--sb-' + $sidebarState()">
      <div class="layout__content">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
